const storage = localStorage;

export function loadStorageItem(key) {
  return storage.getItem(key);
}

export function saveStorageItem(key, value) {
  storage.setItem(key, value);
  return value;
}

export function removeStorageItem(key) {
  storage.removeItem(key);
  return null;
}

export function loadStorageFilter(key) {
  return storage.getItem(`filters.${key}`);
}
export function saveStorageFilter(key, value) {
  storage.setItem(`filters.${key}`, value);
  return value;
}
export function removeStorageFilter(key) {
  storage.removeItem(`filters.${key}`);
  return null;
}

export function loadSessionStorageFilter(key) {
  return sessionStorage.getItem(`filters.${key}`);
}
export function saveSessionStorageFilter(key, value) {
  sessionStorage.setItem(`filters.${key}`, value);
  return value;
}
